import { useWindowSize } from "./useWindowSize";
import { useEffect, useState } from "react";
import { Theme } from "../Theme";

export const useDevice = () => {
    const { width } = useWindowSize();
    const [device, setDevice] = useState("desktop");

    useEffect(() => {
        if (width <= Theme.device.mobile) {
            setDevice("mobile");
        } else if (width <= Theme.device.tablet) {
            setDevice("tablet");
        } else {
            setDevice("desktop");
        }
    }, [width]);

    return device;
};
